// Helles oder dunkles Thema, nach der Einstellung des Systems (ST-UX-001).
//
// KEIN UMSCHALTER IN DER ANWENDUNG, und das ist eine Entscheidung und kein
// Versaeumnis. Wer dunkel will, hat es im Betriebssystem gesetzt -- meist
// einmal, fuer alles. Ein zweiter Schalter in LIAISON erzeugt einen zweiten
// Ort fuer dieselbe Frage, den man gespeichert, synchronisiert und erklaert
// haben will. Solange die Systemeinstellung die richtige Antwort liefert,
// ist der Schalter Aufwand ohne Zugewinn. Kommt der Bedarf, ist er nachtraeglich
// billig: hier steht dann ein Zustand mehr, nicht eine neue Architektur.

import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-color-scheme: dark)';

function subscribe(onChange: () => void): () => void {
  // matchMedia kann fehlen -- in einer Testumgebung ohne Browser, und in sehr
  // alten Ausgaben. Fehlt es, bleibt es beim hellen Thema; ein Absturz des
  // gesamten Rahmens wegen einer Farbfrage waere der falsche Tausch.
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return () => undefined;
  }
  const list = window.matchMedia(QUERY);
  list.addEventListener('change', onChange);
  return () => list.removeEventListener('change', onChange);
}

function prefersDark(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY).matches
    : false;
}

/** `true`, wenn das System ein dunkles Thema verlangt. */
export function usePrefersDark(): boolean {
  return useSyncExternalStore(subscribe, prefersDark, () => false);
}
